module.exports = __webpack_public_path__ + "img/118.1.f01868fb.jpg";